import { Component, ViewEncapsulation } from '@angular/core';

@Component({
    selector: 'fi-side-list-new',
    template: '<ng-content></ng-content>',
    styleUrls: ['./side-list-new.component.scss'],
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-side-list-new' },
    standalone: false,
})
export class SideListNewComponent {}
